import type { CardProfileDto } from "../../types/CardProfileDto";
import type { CardProfileEntity } from "../../types/CardProfileEntity";

export const CardProfileEntityToDto = ({
    cardCircuitCheckReadOnly: _cardCircuitCheckReadOnly,
    posGroupingIdCheckReadOnly: _posGroupingIdCheckReadOnly,
    ifsfAcquirerIdCheckReadOnly: _ifsfAcquirerIdCheckReadOnly,
    loyaltyCodeCheckReadOnly: _loyaltyCodeCheckReadOnly,
    pcNumberCheckReadOnly: _pcNumberCheckReadOnly,
    materialNumberCheckReadOnly: _materialNumberCheckReadOnly,
    midCheckReadOnly: _midCheckReadOnly,
    applicationComponentOPTCheckReadOnly: _applicationComponentOPTCheckReadOnly,
    nationalInternationalFlagCheckReadOnly: _nationalInternationalFlagCheckReadOnly,
    panRangeCheckReadOnly: _panRangeCheckReadOnly,
    matchPatternCheckReadOnly: _matchPatternCheckReadOnly,
    panLengthMinCheckReadOnly: _panLengthMinCheckReadOnly,
    panLengthMaxCheckReadOnly: _panLengthMaxCheckReadOnly,
    aidRangeCheckReadOnly: _aidRangeCheckReadOnly,
    interchangeDesignatorCheckReadOnly: _interchangeDesignatorCheckReadOnly,
    secondByteOfServiceCheckReadOnly: _secondByteOfServiceCheckReadOnly,
    thirdByteOfServiceCheckReadOnly: _thirdByteOfServiceCheckReadOnly,
    dialogueIndicatorCheckReadOnly: _dialogueIndicatorCheckReadOnly,
    releaseCheckReadOnly: _releaseCheckReadOnly,
    productCodesCheckReadOnly: _productCodesCheckReadOnly,
    mobileNumberMaskCheckReadOnly: _mobileNumberMaskCheckReadOnly,
    validationPANCheckReadOnly: _validationPANCheckReadOnly,
    validationCVVCheckReadOnly: _validationCVVCheckReadOnly,
    authCardTypeIdCheckReadOnly: _authCardTypeIdCheckReadOnly,
    dynamicProperties,
    ...rest
}: Readonly<CardProfileEntity>): CardProfileDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    return {
        ...rest,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
